export default "__VITE_ASSET__bcnou$J6__"